import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Servicios
import { UserService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import DJMV from './DJMV';
// import DJMVPrint from '../DJMVPrint/DJMVPrint';

//Estilos

function DJCPContainer() {
    const { token, masters, grapesVariety, settings, formatNumber } =
        useGlobalContext();

    const [loader, setLoader] = useState(false);
    const [print, setPrint] = useState(false);
    const [WatchDJMVLogs, setWatchDJMVLogs] = useState(false);
    const [DJMVData, setDJMVData] = useState({});

    const Params = useParams();

    useEffect(() => {
        // const getMyDJMV = async () => {
        //     try {
        //         setLoader(true);
        //         //Obtenemos la DJMV segun el id que esta en los params
        //         const MyDJMVs = await DJMVService.single({
        //             token,
        //             id: parseInt(Params.id),
        //         });
        //         //Si la respuesta es correcta seteamos el estado de MyDJMV con los datos de la respuesta
        //         if (MyDJMVs) {
        //             const getNombreUsuario = await UserService.getNombreUsuario(
        //                 { token, usuarioId: MyDJMVs.data.cabecera.usuario }
        //             );
        //             if (getNombreUsuario) {
        //                 setDJMVData({
        //                     ...MyDJMVs.data,
        //                     ...getNombreUsuario.data,
        //                 });
        //             }
        //         }
        //         setLoader(false);
        //     } catch (err) {
        //         setLoader(false);
        //         return err;
        //     }
        // };
        // getMyDJMV();
    }, [Params.id]);

    return loader ? (
        <Spinner />
    ) : (
        <>
            <DJMV
                functions={{
                    formatNumber,
                    setPrint,
                    setWatchDJMVLogs,
                }}
                states={{ WatchDJMVLogs, DJMVData, masters }}
            />
            {/* <DJMVPrint
                        functions={{
                            formatNumber,
                            setPrint,
                        }}
                        states={{
                            DJMVData,
                            masters,
                            grapesVariety,
                            settings,
                        }}
                    /> */}
        </>
    );
}

export default DJCPContainer;
